<template>
<div>
  <div class="dialog-footer">
    <el-button size="mini" type="primary" @click="submitForm()">保存</el-button>
    <el-button size="mini" @click="initMeterApportion()">重置分摊对象</el-button>
  </div>
  <div style="display: flex;flex-direction: row;" ref="meterApportion">
    <div style="width: 200px;margin-top: 20px;" ref="meterApportionTree">
      <ProjectTree height="calc(50vh + 300px)" :project_id="mainObj.project_id" :checked_keys="from_data.house_ids" :is-checkbox="true" :is_submit="false" @onNode="onNodeProject"/>
    </div>
    <div class="resize" title="左右侧边栏" ref="resize">⋮</div>
    <div ref="meterApportionList" style="overflow-x: scroll;margin-left:10px;">
      <div style="margin-top: 10px;">
        <el-descriptions direction="vertical" border :column="1">
          <el-descriptions-item label="收费对象检索">
            <el-descriptions class="margin-top" title="" :column="2" size="mini" border :labelStyle="{width: '100px'}">
              <el-descriptions-item label="分摊楼栋">
                <div style="display: flex;flex-direction: row">
                  <SelectProjectTreeComponent :project_id="mainObj.project_id" :checked_keys="from_data.house_ids"/>
                  <el-popover
                    placement="bottom"
                    width="400"
                    trigger="hover">
                    <template #reference>
                      <el-button>添加分摊楼栋</el-button>
                    </template>
                    <template #default>
                      <ProjectTree :project_id="mainObj.project_id" :checked_keys="from_data.house_ids" :is-checkbox="true" @onNode="onNodeProject"/>
                    </template>
                  </el-popover>
                </div>
                <!--        <div style="color: #ff3d00;margin-left: 20px;">选择了下级仪表就不能选择添加收费用户，下级仪表与收费用户二选其一。</div>-->
              </el-descriptions-item>
              <el-descriptions-item label="房产类型">
                <el-checkbox-group size="mini" v-model="from_data.house_type" @change="activeFunc">
                  <el-checkbox :label="1">住宅</el-checkbox>
                  <el-checkbox :label="2">车位</el-checkbox>
                  <el-checkbox :label="3">储藏室</el-checkbox>
                  <el-checkbox :label="4">商铺</el-checkbox>
                  <el-checkbox :label="5">写字楼</el-checkbox>
                </el-checkbox-group>
              </el-descriptions-item>
              <el-descriptions-item label="客户性质">
                <el-checkbox-group size="mini" v-model="from_data.customer_class" @change="activeFunc">
                  <el-checkbox :label="1">个人客户</el-checkbox>
                  <el-checkbox :label="2">企业客户</el-checkbox>
                </el-checkbox-group>
              </el-descriptions-item>
              <el-descriptions-item label="客户类型">
                <el-checkbox-group size="mini" v-model="from_data.customer_type" @change="activeFunc">
                  <el-checkbox :label="1">业主</el-checkbox>
                  <el-checkbox :label="2">租户</el-checkbox>
                  <el-checkbox :label="3">住户</el-checkbox>
                  <el-checkbox :label="4">共有人</el-checkbox>
                  <el-checkbox :label="5">开发商</el-checkbox>
                  <el-checkbox :label="9">其它</el-checkbox>
                </el-checkbox-group>
              </el-descriptions-item>
              <el-descriptions-item label="房态">
                <el-checkbox-group size="mini" v-model="from_data.room_status" @change="activeFunc">
                  <el-checkbox :label="1">空置</el-checkbox>
                  <el-checkbox :label="2">未领</el-checkbox>
                  <el-checkbox :label="3">空关</el-checkbox>
                  <el-checkbox :label="4">装修</el-checkbox>
                  <el-checkbox :label="5">入住</el-checkbox>
                  <el-checkbox :label="6">出租</el-checkbox>
                </el-checkbox-group>
              </el-descriptions-item>
            </el-descriptions>
          </el-descriptions-item>
          <el-descriptions-item label="计算模式设置">
            <el-descriptions class="margin-top" title="" :column="2" size="mini" border :labelStyle="{width: '100px'}">
              <el-descriptions-item label="是否承担线损">
                <el-switch
                  v-model="from_data.is_line_loss"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch>
                <span style="color: #858585;margin-left: 20px;">打开了上级表产生的线损就会累计到本表。</span>
              </el-descriptions-item>
              <el-descriptions-item label="分摊模式">
                <el-select size="mini" v-model="from_data.apportion_type" placeholder="请选择分摊模式" @change="activeFunc" class="w-200">
                  <el-option
                    v-for="item in [{name:'平均分摊',value:'average'},{name:'面积分摊',value:'area'},{name:'用量分摊',value:'usage'},{name:'楼层分摊',value:'floor'},{name:'通用分摊',value:'currency'}]"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-descriptions-item>
              <el-descriptions-item label="是否向上扣减">
                <el-switch
                  v-model="from_data.is_deduct"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch>
                <span style="color: #858585;margin-left: 20px;">打开了就会参与上级表的相减（本级和上级表的相减）。</span>
              </el-descriptions-item>
              <el-descriptions-item label="分摊类型">
                <el-select size="mini" v-model="from_data.apportion_tip" placeholder="请选择分摊类型" class="w-200">
                  <el-option
                    v-for="item in [{name:'用量',value:1},{name:'线损',value:2},{name:'用量+线损',value:3}]"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-descriptions-item>

              <el-descriptions-item label="是否生成费用">
                <el-switch
                  v-model="from_data.is_expenses"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch>
                <span style="color: #858585;margin-left: 20px;">打开后费用会计算出来。</span>
              </el-descriptions-item>
              <el-descriptions-item label="是否设置对象">
                <el-link v-if="from_data.customer_count" type="success">已设置</el-link>
                <el-link v-if="!from_data.customer_count" type="danger">未设置</el-link>
              </el-descriptions-item>
              <el-descriptions-item label="损耗生成费用">
                <el-switch
                  v-model="from_data.is_loss_expenses"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch>
                <span style="color: #858585;margin-left: 20px;">打开后损耗会计算出来。</span>
              </el-descriptions-item>
              <el-descriptions-item label="扩展占比">
                <input type="number" class="number-input" v-model="from_data.proportion_ext" />
                <span style="color: #858585;margin-left: 20px;">设置占比，默认1(直接作用于本表)。</span>
              </el-descriptions-item>
              <el-descriptions-item label="损耗率">
                <input type="number" class="number-input" v-model="from_data.proportion_loss" />
                <span style="color: #858585;margin-left: 20px;">设置损耗率，默认1(直接作用于本表)。</span>
              </el-descriptions-item>
            </el-descriptions>
          </el-descriptions-item>
        </el-descriptions>

      </div>
      <div>
        <Apportion ref="ApportionRef" v-if="from_data.apportion_type==='average'" apportion_type="average" :project_id="mainObj.project_id" :meter_id="mainObj.id" :fromDataWhere="from_data" @save="saveApportion"/>
        <Apportion ref="ApportionRef" v-if="from_data.apportion_type==='area'" apportion_type="area" :project_id="mainObj.project_id" :meter_id="mainObj.id" :fromDataWhere="from_data" @save="saveApportion"/>
        <Apportion ref="ApportionRef" v-if="from_data.apportion_type==='usage'" apportion_type="usage" :project_id="mainObj.project_id" :meter_id="mainObj.id" :fromDataWhere="from_data" @save="saveApportion"/>
        <Apportion ref="ApportionRef" v-if="from_data.apportion_type==='floor'" apportion_type="floor" :project_id="mainObj.project_id" :meter_id="mainObj.id" :fromDataWhere="from_data" @save="saveApportion"/>
        <Apportion ref="ApportionRef" v-if="from_data.apportion_type==='currency'" apportion_type="currency" :project_id="mainObj.project_id" :meter_id="mainObj.id" :fromDataWhere="from_data" @save="saveApportion"/>
      </div>
    </div>
  </div>

<!--  <el-tabs v-model="from_data.apportion_type" @tab-click="activeFunc">-->
<!--    <el-tab-pane label="平均分摊" name="average">-->

<!--    </el-tab-pane>-->
<!--    <el-tab-pane label="面积分摊" name="area">-->

<!--    </el-tab-pane>-->
<!--    <el-tab-pane label="用量分摊" name="usage">-->

<!--    </el-tab-pane>-->
<!--    <el-tab-pane label="楼层分摊" name="floor">-->

<!--    </el-tab-pane>-->
<!--    <el-tab-pane label="通用分摊" name="currency">-->

<!--    </el-tab-pane>-->
<!--  </el-tabs>-->
</div>
</template>

<script>
import Apportion from "./apportion/Apportion";
import MeterTree from "./MeterTree";
import SelectMeterComponent from "./SelectMeterComponent";
import SelectProjectTreeComponent from "./SelectProjectTreeComponent";
import ProjectTree from "./ProjectTree";
import {CommonHelp} from "../../../../Butler/common/CommonHelp";
import MeterHttp from "../../../common/MeterHttp";
export default {
  name: "MeterApportionCustomer",
  inject:['mainObj','componentId','setComponentId','formData'],
  components: {ProjectTree, SelectProjectTreeComponent, SelectMeterComponent, MeterTree, Apportion},
  data(){
    return{
      activeName:"average",
      meter_data:{},
      from_data:{
        meter_id:0,
        project_id:0,
        apportion_meter_type:0,
        apportion_type:'average',
        apportion_fun:"",
        son_meter_ids:"",
        house_ids:"",
        customer_count:0,
        house_type:[1,2,3,4,5],
        customer_class:[1,2],
        customer_type:[1,5],
        room_status:[1,2,3,4,5,6],
        apportion_tip:1,
        is_line_loss:1,
        is_deduct:1,
        is_loss_expenses:1,
        is_expenses:1,
        proportion_ext:1,
        proportion_loss:1,
        proportion_total:0,
      },
      meter_list:[],
      is_house_select:false,
    }
  },
  mounted() {
    const that=this;
    that.meter_data=that.formData();
    that.from_data.meter_id=that.meter_data.id;
    that.from_data.project_id=that.mainObj.project_id;
    that.from_data.apportion_meter_type=1;
    // that.from_data.apportion_type='average';
    that.getData();
    // that.from_data.son_meter_ids="1,2,3,174048,174050";
    // that.from_data.house_ids=""
    that.dragControllerLR({
      resize:that.$refs.resize,
      iframe:that.$refs.meterApportion,
      left:that.$refs.meterApportionTree,
      right:that.$refs.meterApportionList
    },({leftWidth})=>{
      that.leftWidth=leftWidth;
    });
  },
  methods:{
    querySearchAsyncRoom(queryString, cb){
      const that=this;
      if(!queryString){
        cb([]);
      }else {
        MeterHttp.post("Meter/getMeterKeyValue?user_type="+(that.$route.query.type||0),{keyWord:queryString,project_id:that.mainObj.project_id},ret=>{
          if(ret.code) {
            cb(ret.data)
          }else {
            cb([])
          }
        })
      }
    },
    handleSelect(item) {
      this.from_data.upid=item.id;
    },
    onNode(data){
      let meter_ids=data.map(ret=>ret.id);
      this.from_data.son_meter_ids=meter_ids.join(',')
      // console.log(meter_ids);
    },
    onNodeProject(data){
      let house_ids=data.map(ret=>ret.house_id);
      this.from_data.house_ids=house_ids.join(',')
      this.$refs.ApportionRef.getHouseCustomer(this.from_data)
    },
    activeFunc(index){
      const that=this;
      CommonHelp.throttle(function () {
        that.from_data.house_ids&&that.$refs.ApportionRef.getHouseCustomer(that.from_data)
        that.from_data.son_meter_ids&&that.$refs.ApportionRef.getSonMeterCustomer(that.from_data)
      },1000,that);
    },
    submitForm(){
      const that=this;
      // if(that.from_data.son_meter_ids&&that.from_data.house_ids){
      //   that.$message.error('下级表与添加用户二者只能选择其一');
      //   return false;
      // }
      // if(!that.from_data.son_meter_ids&&!that.from_data.house_ids){
      //   that.$message.error('下级表与添加用户二者必须选择其一');
      //   return false;
      // }

      if(that.from_data.son_meter_ids){
        //线损表
        that.from_data.apportion_meter_type=2;
      }else {
        //分摊表
        that.from_data.apportion_meter_type=1;
      }

      that.setData((data)=>{
        let apportion_object_list=that.$refs.ApportionRef.getTableData();
        that.setApportionObject(apportion_object_list,()=>{
          that.$message.success('设置成功');
        })
        that.from_data.id=data.id;

      })
    },
    initObjectList(){
      const that=this;
      that.from_data.customer_count=0;
      that.from_data.proportion_total=0;
      let from_data=ERP.reJson(that.from_data);
      from_data.house_type=from_data.house_type.filter(ret=>ret>0).join(',');
      from_data.customer_class=from_data.customer_class.filter(ret=>ret>0).join(',');
      from_data.customer_type=from_data.customer_type.filter(ret=>ret>0).join(',');
      from_data.room_status=from_data.room_status.filter(ret=>ret>0).join(',');
      MeterHttp.post("MeterApportion/setMeter",{...from_data},ret=>{
        if(ret.code){
          that.setApportionObject([],()=>{
            that.$message.success('初始化成功');
            that.$refs.ApportionRef.pageChange(1);
          })
        }
      })

    },
    getData(){
      const that=this;
      MeterHttp.get("MeterApportion/getMeter",{
        project_id:that.mainObj.project_id,
        meter_id:that.mainObj.id,
      },ret=>{
        if(ret.code){
          ret.data.house_type=(ret.data.house_type||"").split(',').map(ret=>ret*1);
          ret.data.customer_class=(ret.data.customer_class||"").split(',').map(ret=>ret*1);
          ret.data.customer_type=(ret.data.customer_type||"").split(',').map(ret=>ret*1);
          ret.data.room_status=(ret.data.room_status||"").split(',').map(ret=>ret*1);
          that.from_data=Object.assign(that.from_data,ret.data);
          that.$nextTick(function () {
            if(that.from_data.son_meter_ids){
              that.$refs.ApportionRef.getSonMeterCustomer(that.from_data);
            }else {
              that.$refs.ApportionRef.getHouseCustomer(that.from_data);
            }
          })

        }
      })
    },
    setData(callback){
      const that=this;
      let apportion_object_list=that.$refs.ApportionRef.getTableData();
      let apportion_config_list=that.$refs.ApportionRef.getApportionConfigList();
      that.from_data.customer_count=apportion_object_list.length;
      that.from_data.proportion_total=(apportion_object_list[0]||{}).total||0;
      that.from_data.apportion_fun=JSON.stringify(apportion_config_list);
      let from_data=ERP.reJson(that.from_data);
      from_data.house_type=from_data.house_type.filter(ret=>ret>0).join(',');
      from_data.customer_class=from_data.customer_class.filter(ret=>ret>0).join(',');
      from_data.customer_type=from_data.customer_type.filter(ret=>ret>0).join(',');
      from_data.room_status=from_data.room_status.filter(ret=>ret>0).join(',');
      MeterHttp.post("MeterApportion/setMeter",{...from_data},ret=>{
        if(ret.code){
          callback(ret.data)
        }
      })
    },
    setApportionObject(apportion_object_list=[],callback){
      const that=this;
      MeterHttp.post("MeterApportionObject/setObjectList",{
        project_id:that.mainObj.project_id,
        meter_id:that.mainObj.id,
        apportion_object_list:JSON.stringify(apportion_object_list),
      },ret=>{
        if(ret.code){
          callback()
        }
      })
    },
    saveApportion(callback){
      const that=this;
      that.setData((data)=>{
        let apportion_object_list=that.$refs.ApportionRef.getTableData();
        that.setApportionObject(apportion_object_list,()=>{
          typeof callback==="function"&&callback()
        })
        that.from_data.id=data.id;
      })
    },
    initMeterApportion(){
      const that=this;
      if(!that.mainObj.id){
        that.$message.error('请选择仪表再批量重置');
        return false;
      }
      that.$confirm('确认要批量重置所选仪表分摊模式吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        MeterHttp.post("MeterApportion/deleteMeterApportion",{
          project_id:that.mainObj.project_id,
          meter_ids: that.mainObj.id+'',
        }, res => {
          that.$message.success('批量重置成功');
          that.getData();
        })
      }).catch(() => {
        that.$message.error('取消批量重置');
      });
    },
    dragControllerLR({resize,iframe, left, right},callback) {
      const that=this;
      resize.onmousedown = function (e) {
        //颜色改变提醒
        resize.style.background = "#818181";
        let startX = e.clientX;
        resize.left = resize.offsetLeft;
        // 鼠标拖动事件
        document.onmousemove = function (e) {
          let endX = e.clientX;
          let moveLen = resize.left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
          let maxT = iframe.clientWidth - resize.offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度

          if (moveLen < 50) moveLen = 50; // 左边区域的最小宽度为50px
          if (moveLen > maxT - 150) moveLen = maxT - 150; //右边区域最小宽度为150px

          resize.style.left = moveLen; // 设置左侧区域的宽度

          typeof callback=== "function" && callback({
            moveLen: moveLen,
            maxT: maxT,
            leftWidth: (moveLen-5) + "px",
            rightWidth: iframe.clientWidth - moveLen - 10 + "px"
          });

          left.style.width = moveLen + "px";
          right.style.width = iframe.clientWidth - moveLen - 10 + "px";

        };
        // 鼠标松开事件
        // eslint-disable-next-line no-unused-vars
        document.onmouseup = function (evt) {
          //颜色恢复
          resize.style.background = "#d6d6d6";
          document.onmousemove = null;
          document.onmouseup = null;
          resize.releaseCapture && resize.releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
        };
        resize.setCapture && resize.setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
        return false;
      };
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common";
/* 拖拽区div样式 */
.resize {
  cursor: w-resize;
  float: left;
  position: relative;
  top: 45%;
  background-color: #d6d6d6;
  border-radius: 5px;
  width: 10px;
  height: 50px;
  background-size: cover;
  background-position: center;
  /*z-index: 99999;*/
  font-size: 32px;
  color: white;
  margin:auto 0;
  text-align: center;
}
.number-input{
  background-color: #ffe5d5;
  color: black;
  width: 100px;
  &[disabled]{
    background-color: #ececec;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/MeterApportionCustomer.vue